export default __webpack_public_path__ + "static/media/token.1062400e.mp4";